import { UserContext } from '@/contexts/user-context'
import type { IMe } from '@/interface/auth.interface'
import React from 'react'

interface UserProviderProps {
  children: React.ReactNode
}

export const UserProvider: React.FC<UserProviderProps> = ({ children }) => {
  const [me, setMe] = React.useState<IMe | null>(null)

  const value = React.useMemo(
    () => ({
      me,
      setMe,
    }),
    [me]
  )

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>
}
